
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">AI数字人生成：开启元宇宙新时代</h2>
                    <div class="time">2023-10-16 11:00:10</div>
                    <div class="start">
                        随着人工智能技术的飞速发展，我们进入了一个令人惊叹的新时代——元宇宙时代。这个虚拟的数字世界是一个无限的、持续扩张的、包含多个虚拟世界的宇宙。在这个宇宙中，人们可以通过虚拟化身，与其他用户交互、参与虚拟活动、探索虚拟世界。而AI数字人生成技术，是开启元宇宙新时代的关键。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/249.png" alt="AI数字人生成：开启元宇宙新时代" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t">
                        </div>
                        <div class="list-text">
                            AI数字人生成 AI数字人生成是指使用人工智能技术，生成虚拟的数字人物。这种技术可以根据真人的照片、视频、声音等数据，生成外貌、动作、表情、声音等高度真实的虚拟人物。例如，可以根据用户的照片，生成用户的虚拟化身；可以根据用户的动作、表情数据，生成虚拟化身的动作、表情。
                        </div>

                    </div>
                    <div class="list">
                        <div class="list-t">
                        </div>
                        <div class="list-text">
                            AI数字人的应用 AI数字人有多种应用场景。
                        </div>

                    </div>
                    <div class="list">
                        <div class="list-text">

                            元宇宙：用户可以使用自己的AI数字人，作为元宇宙中的虚拟化身。这样，用户可以在元宇宙中，以自己的虚拟化身，与其他用户交互、参与虚拟活动、探索虚拟世界。
                        </div>
                        <div class="list-text">

                            社交媒体：用户可以使用自己的AI数字人，进行在线社交。例如，在社交媒体上，用户可以使用自己的AI数字人，进行视频聊天、直播等。
                        </div>
                        <div class="list-text">

                            游戏：用户可以使用自己的AI数字人，作为游戏的角色。这样，用户可以在游戏中，体验不同的角色扮演。
                        </div>
                        <div class="list-text">

                            教育：教师可以使用AI数字人，作为教学的辅助工具。例如，可以使用AI数字人，模拟历史人物、虚拟实验等。
                        </div>


                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">

                            开启元宇宙新时代 元宇宙是一个虚拟的数字世界，是未来的互联网。在这个世界中，人们可以通过虚拟化身，与其他用户交互、参与虚拟活动、探索虚拟世界。而AI数字人生成技术，为用户提供了高度真实的虚拟化身，使得用户可以在元宇宙中，得到更加真实、个性化的体验。
                        </div>
                        
                    </div>



                    <div class="end">
                        总的来说，AI数字人生成技术，是开启元宇宙新时代的关键。通过这种技术，用户可以得到高度真实的虚拟化身，可以在元宇宙、社交媒体、游戏、教育等多个领域，得到更加真实、个性化的体验。

                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "AI数字人生成：开启元宇宙新时代-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "AI数字人生成：开启元宇宙新时代,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "随着人工智能技术的飞速发展，我们进入了一个令人惊叹的新时代——元宇宙时代",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo249.vue